module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": _vm.titulo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Entidades")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": true
    }
  }, [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Razão social"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome),
      expression: "entidade.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "text",
      "mask": "NN.NNN.NNN/NNNN-##",
      "tokens": _vm.$cnpjTokens
    },
    model: {
      value: (_vm.entidade.ds_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ds_cnpj", $$v)
      },
      expression: "entidade.ds_cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpjExpeditionTime')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cnpjExpeditionTime"
    }
  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.dt_data_expedicao_cnpj),
      expression: "entidade.dt_data_expedicao_cnpj"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "date",
      "format": _vm.formatDate
    },
    domProps: {
      "value": (_vm.entidade.dt_data_expedicao_cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "dt_data_expedicao_cnpj", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome fantasia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome fantasia"
    }
  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_nome_fantasia),
      expression: "entidade.ds_nome_fantasia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Nome fantasia",
    staticClass: "form-control",
    attrs: {
      "name": "Nome fantasia",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_nome_fantasia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_nome_fantasia", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('forma_juridica')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "forma_jurídica"
    }
  }, [_vm._v(" Natureza jurídica: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaFormasJuridicas,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione uma Natureza Jurídica",
      "track-by": "codigo",
      "custom-label": _vm.etiquetaListaFormaJuridica,
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "forma_juridica",
      "data-vv-as": "Natureza jurídica"
    },
    model: {
      value: (_vm.entidade.forma_juridica),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "forma_juridica", $$v)
      },
      expression: "entidade.forma_juridica"
    }
  }), _vm._v(" "), (_vm.errors.first('forma_juridica')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('forma_juridica')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('ramos_atividade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "ramos_atividade"
    }
  }, [_vm._v(" Ramos de Atividade: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaRamosAtividade,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": "Selecione os Ramos de Atividade",
      "label": "ds_codigo",
      "track-by": "ds_codigo",
      "custom-label": _vm.etiquetaListaRamosAtividade,
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "ramos_atividade",
      "data-vv-as": "Ramos de Atividade"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "multiselect__tag"
        }, [_c('span', [_vm._v(_vm._s(props.ds_codigo))]), _c('span', {
          staticClass: "custom__remove",
          on: {
            "click": function($event) {
              return props.remove(props)
            }
          }
        }, [_vm._v("❌")])])]
      }
    }]),
    model: {
      value: (_vm.entidade.ramos_atividade),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "ramos_atividade", $$v)
      },
      expression: "entidade.ramos_atividade"
    }
  }), _vm._v(" "), (_vm.errors.first('ramos_atividade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('ramos_atividade')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('listaDocConstituicao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "listaDocConstituicao"
    }
  }, [_vm._v(" Documento de constituição: ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaDocConstituicao,
      "multiple": false,
      "close-on-select": true,
      "searchable": false,
      "track-by": "id",
      "label": "ds_tipo",
      "placeholder": "Selecione um Documento de constituição",
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "listaDocConstituicao",
      "data-vv-as": "Documento de constituição"
    },
    model: {
      value: (_vm.entidade.documento_constituicao),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "documento_constituicao", $$v)
      },
      expression: "entidade.documento_constituicao"
    }
  }), _vm._v(" "), (_vm.errors.first('listaDocConstituicao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('listaDocConstituicao')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-lg-6",
    attrs: {
      "id": "contato"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": true
    }
  }, [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Telefone"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [(_vm.entidade.contato) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.contato.ds_telefone),
      expression: "entidade.contato.ds_telefone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) ####-#####'),
      expression: "'(##) ####-#####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "masked": _vm.masked,
      "name": "Telefone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.contato.ds_telefone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade.contato, "ds_telefone", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [(_vm.entidade.contato) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.contato.ds_celular),
      expression: "entidade.contato.ds_celular"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) #####-#####'),
      expression: "'(##) #####-#####'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": _vm.masked,
      "name": "mobile",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.contato.ds_celular)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade.contato, "ds_celular", $event.target.value)
      }
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_email),
      expression: "entidade.ds_email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Email",
    staticClass: "form-control",
    attrs: {
      "name": "Email",
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.entidade.ds_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo E-mail é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.ds_website),
      expression: "entidade.ds_website"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:255'),
      expression: "'max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "website",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.ds_website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "ds_website", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "possuiCebas"
    }
  }, [_vm._v("Possui CEBAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCebas),
      expression: "possuiCebas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCebas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCebas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "possuiCmas"
    }
  }, [_vm._v("Possui CMAS/CAS:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.possuiCmas),
      expression: "possuiCmas"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "possuiCmas"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.possuiCmas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Não")]), _vm._v(" "), _c('option', [_vm._v("Sim")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(1), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.entidade.endereco,
      "disable": _vm.disable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('dirigentes', {
    attrs: {
      "entDirigentes": _vm.entidade.dirigentes,
      "entidadeParceira": _vm.entidade,
      "name": "dirigentes",
      "disable": _vm.disable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('assinaturaDirigentes', {
    attrs: {
      "visualiza": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('usuarios', {
    attrs: {
      "entUsuarios": _vm.entidade.usuarios,
      "disable": _vm.disable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.entidade.documentos,
      "documentTypes": '',
      "disable": _vm.disable,
      "local-uso": 'TODOS'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(6), _vm._v(" "), _c('historico-entidade', {
    attrs: {
      "entHistorico": _vm.historico
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Entidade - Visualização")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Assina convênio com a Fundação BB:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuários da entidade:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02216ac4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/entidade/VisualizaEntidades.vue
// module id = 1850
// module chunks = 1